import React from 'react';
import { Card, CardContent, Box, Typography } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { pl } from 'date-fns/locale';

interface DateRangeFilterProps {
  startDate: Date;
  endDate: Date;
  onStartDateChange: (date: Date | null) => void;
  onEndDateChange: (date: Date | null) => void;
}

const DateRangeFilter: React.FC<DateRangeFilterProps> = ({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
}) => {
  const { t } = useTranslation();

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={pl}>
      <Card sx={{ mb: 4 }}>
        <CardContent>
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, 1fr)' },
              gap: 3,
              alignItems: 'center',
            }}
          >
            <Box>
              <DatePicker
                label={t('statistics.startDate')}
                value={startDate}
                onChange={onStartDateChange}
                format="dd.MM.yyyy"
                slotProps={{ textField: { fullWidth: true } }}
              />
            </Box>
            <Box>
              <DatePicker
                label={t('statistics.endDate')}
                value={endDate}
                onChange={onEndDateChange}
                minDate={startDate}
                format="dd.MM.yyyy"
                slotProps={{ textField: { fullWidth: true } }}
              />
            </Box>
          </Box>
        </CardContent>
      </Card>
    </LocalizationProvider>
  );
};

export default DateRangeFilter;

